import { render } from "./PlanetsTable.vue?vue&type=template&id=d4547d46&scoped=true"
import script from "./PlanetsTable.vue?vue&type=script&lang=js"
export * from "./PlanetsTable.vue?vue&type=script&lang=js"

import "./PlanetsTable.vue?vue&type=style&index=0&id=d4547d46&scoped=true&lang=css"

import exportComponent from "/codebuild/output/src2784445594/src/vedicastrochart-vuejs/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-d4547d46"]])

export default __exports__